import React, { useEffect } from 'react';
import { Switch, useHistory } from 'react-router-dom';
import { PERMISSION_GROUPS } from '~/accessControl/permissionGroups';
import RouterSuspense from '~/app/common/RouterSuspense';
import PrivateRoute from '~/app/PrivateRoute';
import { ROUTES } from '~/app/Router';
import { useStoreActions, useStoreState } from '~/store';
import List from './';
import Detail from './Detail';

export const TASK_ROUTES = {
  list: '/tasks',
  issue: '/tasks/issue/:id',
  service: '/tasks/service/:id',
  workorder: '/tasks/workorder/:id'
};

export type RouterComponent = React.FC

const Router: RouterComponent = () => {
  const history = useHistory();
  const netWorkStatus = useStoreState(state => state.app.offline.status);
  const projectList = useStoreState(state => state.projects.list);
  const projectFetchAction = useStoreActions(actions => actions.projects.fetch);

  useEffect(() => {
    if (netWorkStatus === 0) {
      projectList.length === 0 && projectFetchAction();
    } else {
      history.push(ROUTES.projects);
    }
  }, [projectFetchAction, netWorkStatus, history, projectList]);

  return (
    <RouterSuspense>
      <Switch>
        <PrivateRoute path={TASK_ROUTES.issue} component={Detail} requiredPermissions={PERMISSION_GROUPS.oppgaver} />
        <PrivateRoute path={TASK_ROUTES.service} component={Detail} requiredPermissions={PERMISSION_GROUPS.oppgaver} />
        <PrivateRoute path={TASK_ROUTES.workorder} component={Detail} requiredPermissions={PERMISSION_GROUPS.oppgaver} />
        <PrivateRoute path={TASK_ROUTES.list} component={List} requiredPermissions={PERMISSION_GROUPS.oppgaver} />
      </Switch>
    </RouterSuspense>
  );
};

export default Router;